module.exports = __webpack_public_path__ + "img/status_load_framework.e6690a18.gif";